import styled from '@emotion/styled';

// Custom Fields
import PropTypes from 'prop-types';

import { Grid } from 'views/anyguide/messages/styles';
import { Theme } from 'ui_system/theme';
import SimpleNumber from 'ui_system/forms/SimpleNumber';

import CircleMinusIcon from 'views/ui/icons/circle-minus-icon';
import CirclePlusIcon from 'views/ui/icons/circle-plus-icon';

import { t } from 'services/translation';
import { Label, Text, TextField, SubLabel } from './FormStyles';

const SuppliesSection = styled('div')`
  width: 100%;
`;

const Card = styled('div')`
  padding: 15px;
  margin-top: 30px;
  background: ${Theme.colors.backgroundColor};
  display: grid;
`;

const List = styled('div')`
  margin: 10px 0 0;
`;

const ListItem = styled(Grid)`
  margin-bottom: 30px;
`;

const ItemName = styled('input')``;

const ItemUrl = styled(ItemName)`
  grid-column-end: span 2;
`;

const ItemQuantity = styled(SimpleNumber)`
  text-align: center;
`;

const DeleteButton = styled(CircleMinusIcon)`
  fill: ${(props) => props.color || Theme.colors.linksDesignElementsBaseColor};
  align-self: center;
  cursor: pointer;
  width: 20px;
  height: 20px;
`;

const AddButton = styled(CirclePlusIcon)`
  cursor: pointer;
  fill: ${(props) => props.color || Theme.colors.linksDesignElementsBaseColor};
  vertical-align: middle;
  margin-right: 6px;
  position: relative;
  top: -1px;
  width: 20px;
  height: 20px;
`;

const AddLink = styled(Text)`
  color: ${(props) => props.color || Theme.colors.linksDesignElementsBaseColor};
  cursor: pointer;
`;

const textFieldProps = {
  css: TextField,
  type: 'text',
};

const ItemList = (props) => {
  const { items, onUpdate, color, title, subTitle, itemObj } = props;

  const deleteItem = (i) => {
    const { field } = props;
    const newItems = items.filter((item, index) => i !== index);
    if (newItems.length > 0) {
      onUpdate(field.name, newItems);
    } else {
      onUpdate(field.name, [{ ...itemObj }]);
    }
  };

  const addItem = () => {
    const { field, itemObj } = props;
    items.push({ ...itemObj });
    onUpdate(field.name, items);
  };

  const handleNameChange = (e, index) => {
    const { field } = props;
    items[index].textAnswer = e.target.value; // TODO: decouple naming - something like `text`
    onUpdate(field.name, items);
  };

  const handleQuantityChange = (index, value) => {
    const { field } = props;
    items[index].quantity = value;
    onUpdate(field.name, items);
  };

  const handleUrlChange = (e, index) => {
    const { field } = props;
    items[index].supplyUrl = e.target.value;
    onUpdate(field.name, items);
  };

  const renderItems = () => {
    return (
      <List>
        {items.map((item, index) => {
          return (
            <ListItem
              gridTemplateColumns="1fr 85px 25px"
              gridGap="10px"
              key={index}
            >
              <ItemName
                onChange={(e) => handleNameChange(e, index)}
                value={item.textAnswer}
                placeholder={item.textAnswerPlaceholder}
                {...textFieldProps}
              />
              <ItemQuantity
                placeholder={item.quantityPlaceholder}
                integerOnly
                handleNumberInput={handleQuantityChange}
                field={{ name: index, value: item.quantity }}
              />
              <DeleteButton color={color} onClick={() => deleteItem(index)} />
              <ItemUrl
                onChange={(e) => handleUrlChange(e, index)}
                value={item.supplyUrl}
                placeholder={item.supplyUrlPlaceholder}
                {...textFieldProps}
              />
            </ListItem>
          );
        })}
        <AddLink onClick={addItem} color={color}>
          <AddButton color={color} /> {t('ADD_ANOTHER_ITEM')}
        </AddLink>
      </List>
    );
  };

  return (
    <SuppliesSection>
      <Card>
        <Label>{title}</Label>
        <SubLabel>{subTitle}</SubLabel>
        {renderItems()}
      </Card>
    </SuppliesSection>
  );
};
export default ItemList;

ItemList.propTypes = {
  field: PropTypes.object.isRequired,
  onUpdate: PropTypes.func.isRequired,
  itemObj: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired,
};

// ItemList.defaultProps = {
// };
